import { useCart } from 'context/CartContex';
import React, { useState } from 'react';
import ReactLoading from "react-loading";
import axiosInstance from 'services/axiosInstance';
import * as S from './styles';
//components
import Camera from '../../../Camera';
//Icons
import { Barcode, FlagBanner, MagnifyingGlass } from "@phosphor-icons/react";
//hooks
import useLoading from "../../../../hooks/useLoading";
import { useMultipleModal } from "../../../../hooks/useMultipleModal";
//Interface
import { IAcessory } from "Interfaces/IAccessory";
import { ICustomer } from "Interfaces/ICustomerAddress";
import { IFrame } from "Interfaces/IFrame";
import { ILens } from "Interfaces/ILens";
import { IService } from "Interfaces/IService";
interface IProps {
    placeholder: string;
    htmlFor: string;

    typeField: 'customer' | 'sale';
    url: string;
    onSelect: (value: any) => void;
}
export default function SearchField({
    placeholder,
    htmlFor,
    typeField,
    url,
    onSelect
}: IProps) {
    // Estados e funções para controle do modal
    const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
    const [searchTerm, setSearchTerm] = useState("");
    const {
        isLoading,
        startLoading,
        stopLoading,
    } = useLoading();
    const [data, setData] = useState<(
        IFrame &
        IService &
        ILens &
        IAcessory
    )[]>([]);
    const [customer, setCustomer] = useState<ICustomer[]>([]);
    const { addToCart } = useCart();

    // Função para capturar valor digitado na pesquisa
    const handleInputChange = (
        event: React.ChangeEvent<HTMLInputElement>,
    ) => {
        const value = event.target.value;
        if (value !== "") {
            setSearchTerm(value);
        }
    };

    // Função para lidar com o clique do botão de pesquisa
    const handleButtonSearch = () => {
        toggleModalVisibility(typeField);
        fetchData(searchTerm);
    }

    // Função que retorna o nome correto para exibir no título
    const getProductDisplayName = (val: any): string => {
        switch (val.type) {
            case 'lens':
                return val.name_lens || val.code || '-';
            case 'frame':
                return val.code || '-';
            case 'service':
                return `${val.name || ''}`;
            default:
                return val.name || val.code || val.barcode || '-';
        }
    };

    const getProductDisplayDetails = (val: any): string => {
        switch (val.type) {
            case 'lens':
                return val.name_lens || val.code || '-';
            case 'frame':
                return `Grife: ${val.brands?.brand || '-'} | Cor: ${val.color || '-'} | Tamanho: ${val.size || '-'}/${val.bridge || '-'}/${val.haste || '-'}`;
            case 'service':
                return `${val.name || ''}`;
            default:
                return val.name || val.code || val.barcode || '-';
        }
    };

    // Função para lidar com o clique do botão do menu pop-up
    const handleButtonClick = (item: any) => {
        toggleModalVisibility(typeField);
        onSelect(item);

        if (typeField === 'sale') {
            const product = {
                id: item.id.toString(),
                code: getProductDisplayName(item),
                type: item.type,
                amount: item.amount,
                price: parseFloat(item.price),
                details: getProductDisplayDetails(item),
            };
            handleAddToCart(product);
        }
    }

    // Pesquisar e armazenar os resultados da pesquisa
    const fetchData = async (term: string) => {
        startLoading();
        try {
            const response = await axiosInstance.get(`${url}?&search=${term}`);
            const {
                accessories = [],
                frames = [],
                lenses = [],
                services = []
            } = response.data;

            // Verificar se há resultados
            const combinedResults = [
                ...accessories.map((item: IAcessory) => ({ ...item, type: 'accessories' })),
                ...frames.map((item: IFrame) => ({ ...item, type: 'frame' })),
                ...lenses.map((item: ILens) => ({ ...item, type: 'lens' })),
                ...services.map((item: IService) => ({ ...item, type: 'service' }))
            ];

            if (combinedResults.length > 0) {
                setData(combinedResults);
            } else if (typeField === 'customer' && response.data.data.length > 0) {
                setCustomer(response.data.data);
            }
        } catch (error) {
            console.log("Error: ", error);
        } finally {
            stopLoading();
        }
    };

    // Função para adicionar produtos ao carrinho
    const handleAddToCart = (selectedProducts: any) => {
        try {
            addToCart(selectedProducts);
        } catch (error) {
            console.error('Erro ao adicionar produto:', error);
        }
    };

    //Função de Scanner
    const handleScanResult = (result: string | null) => {
        if (result) {
            fetchData(result);
            toggleModalVisibility(typeField);
            toggleModalVisibility("scanner"); // Fechar modal após escanear
        }
    };

    return (
        <S.SearchFieldContainer>
            <S.ContentInput
                className={typeField == 'customer' ? 'border-bottom' : ''}
            >
                <S.Input
                    id={htmlFor}
                    type="text"
                    placeholder={placeholder}
                    className='input-border-none'
                    autoComplete="off"
                    onChange={(e) => handleInputChange(e)}
                />

                <S.ContentButton>

                    {
                        typeField === 'sale' &&
                        <S.Button
                            type='button'
                            onClick={(e) => {
                                e.preventDefault();
                                toggleModalVisibility('scanner');
                            }}
                        >
                            <Barcode size={18} />
                        </S.Button>
                    }
                    <S.Button
                        type='button'
                        onClick={handleButtonSearch}
                        disabled={isLoading}>
                        {isLoading ? (
                            <ReactLoading
                                type="spokes"
                                color="white"
                                height="20px"
                                width="20px"
                            />
                        ) : (
                            <MagnifyingGlass size={18} />
                        )}
                    </S.Button>
                </S.ContentButton>
            </S.ContentInput>

            {isOpenModal(typeField) &&
                <S.PopMenu ref={(ref) => assignRef(typeField, ref)}>
                    {
                        data.length > 0 ? (
                            data.map((item) => (
                                <S.ButtonMenu
                                    key={item.id}
                                    type='button'
                                    onClick={() => handleButtonClick(item)}
                                >
                                    {item.name || item.code || item.name_lens}
                                </S.ButtonMenu>
                            ))
                        ) : customer.length > 0 ? (
                            customer.map((item) => (
                                <S.ButtonMenu
                                    key={item.id}
                                    type='button'
                                    className={item.flag}
                                    onClick={() => handleButtonClick(item)}
                                >
                                    {
                                        item.flag &&
                                        <FlagBanner size={12} weight="fill" />
                                    }
                                    {item.full_name}
                                    {
                                        item.cpf &&
                                        (item.cpf)
                                    }
                                </S.ButtonMenu>
                            ))
                        ) : (
                            <S.EmptyList>
                                <p>Nenhum resultado encontrado</p>
                            </S.EmptyList>
                        )
                    }
                </S.PopMenu>
            }

            <Camera
                isOpenModalCamera={isOpenModal("scanner")}
                setModalClose={() => toggleModalVisibility("scanner")}
                onScanResult={handleScanResult}
            />
        </S.SearchFieldContainer>
    )
}